<nav id="{{ id() }}Navbar" class="d-flex overflow-x-auto"
    [ngClass]="{
        'py-3 px-0 p-md-3 gap-3': !dynamic() && viewportService.isViewportSm(),
        'navbar-nav flex-row px-4': dynamic() || viewportService.isViewportSm() === false,
        'flex-lg-column px-lg-0 pb-lg-8': dynamic(),
        'display-sidebar': dynamic() && isViewportLg,
    }"
    aria-label="{{ ariaLabel() }} navbar">
    @for (item of navigationItems(); track $index) {
        @if (!dynamic() && viewportService.isViewportSm()) {
            <pp-button [nowrap]="true"
                [shape]="buttonShape.Square"
                [variant]="item.active ? buttonVariant.Primary : buttonVariant.Transparent"
                (buttonClick)="onItemClick(item.id)">{{ item.label }}</pp-button>
        }
        @else {
            <ng-container [ngTemplateOutlet]="navbarBtn" [ngTemplateOutletContext]="{ item: item, }" />
        }
    }
</nav>

<ng-template #navbarBtn let-item="item">
    <div id="{{ item.id }}NavbarItemContainer">
        <div class="navbar-item-width-retainer"></div>
        <a ngbnavlink role="tab" tabindex="0" id="{{ item.id }}NavbarItem" class="navbar-item heading-5 cursor-pointer d-flex px-6 py-6 text-nowrap text-decoration-none"
            [ngClass]="{
                'ps-lg-10 pe-lg-0': dynamic(),
                'display-sidebar': dynamic() && isViewportLg,
                'active': item.active,
                'navbar-item-mobile': item.mobileDisplayOnly,
                'justify-content-center': !dynamic() || !isViewportLg,
            }"
            [attr.aria-label]="item.label"
            (click)="onItemClick(item.id)"
            (keyup)="onItemKeyPress($event, item.id)">

            @if (item.icon) {
                <img class="d-none d-lg-block" [alt]="item.label" [src]="resolveImageIcon(item.icon)" />
            }
            <span [class.ms-lg-3]="item.icon">{{ item.label }}</span>
        </a>
    </div>
</ng-template>
